export default __webpack_public_path__ + "static/matomo_m-a1b8b0cba88664b4e21ac50941966afe.png";